<div class="icon"></div>
<div class="body">
  <h1 class="title"><result-badge *ngFor="let badge of model.badges" [model]="badge"></result-badge>{{ model.message }}</h1>
  <div class="tag-group">
    <result-tag [model]="{ text: 'Create Issue', backgroundColor: '#40aeff', textColor: '#FFFFFF', onClick: {} }" (click)="createIssue()">
    </result-tag>
    <result-tag [model]="{ text: 'View Resource', backgroundColor: '#40aeff', textColor: '#FFFFFF', onClick: {} }" (click)="openDialog()">
    </result-tag>
    <result-tag *ngFor="let tag of model.tags; index as i" [model]="tag" (invoke)="onInvoke($event)"> </result-tag>
  </div>
  <stack-viewer class="stack" #stack [stack]="model.stack"></stack-viewer>
</div>
